Fundu.Components.DatePicker = (function($) {

    var getDate = function(type, number) {
        var date = $('#' + type + 'Day_' + number).val();
        var month = $('#' + type + 'Month_' + number).val();
        var year = $('#' + type + 'Year_' + number).val();

        return year + "-" + addLeadingZero(month) + "-" + addLeadingZero(date);
    }

    var addLeadingZero = function(digit) {
        return digit !== null && digit.length < 2 ? "0" + digit : digit;
    }

    // Reveal public methods
    return {
        getDate: getDate
    }


})(jQuery)